import { ShortCode } from '@highereducation/wordpress';
import { Hero, HeroProps } from '@highereducation/hen-ui';

interface HeroShortcodeProps extends Omit<HeroProps, 'children'> {
  'img-src': string;
  'img-alt'?: string;
  'img-class'?: string;
  'background-image'?: string;
  'content-gap'?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  variant?: 'img-left' | 'img-right';
  children?: React.ReactNode;
  [key: string]: unknown;
}

export const HeroShortcode: ShortCode<HeroShortcodeProps> = {
  component: ({
    variant = 'img-left',
    'img-src': imgSrc,
    'img-alt': imgAlt,
    'img-class': imgClass,
    'background-image': backgroundImage,
    'content-gap': contentGap,
    children,
  }) => {
    return (
      <Hero
        variant={variant}
        imgSrc={imgSrc}
        imgAlt={imgAlt}
        imgClass={imgClass}
        backgroundImage={backgroundImage}
        contentGap={contentGap}
      >
        {children}
      </Hero>
    );
  },
};
